import * as angular from 'angular';
import { DistanceToGradModule } from './views/distance-to-grad-metrics/distance-to-grad.module';
import { CohortModule } from './views/grad-planning-metrics/cohorts/cohort.module';

namespace nv.SchoolMetricsModule {
  'use strict';

  angular.module('nv.SchoolMetricsModule', [
    'md.data.table',
    'nv.shared.services',
    'nv.shared.modals',
    'nv.shared.error-handling',
    CohortModule,
    DistanceToGradModule,
  ]);
}
